import React from 'react';

const HerokuLogo = props => (
  <svg viewBox="0 0 48 48" width={32} height={32} {...props}>
    <path
      d="M7 41V7c0-2.21 1.79-4 4-4h26c2.21 0 4 1.785 4 3.992v34.012C41 43.214 39.21 45 37 45H11c-2.21 0-4-1.79-4-4z"
      fill="#7e57c2"
    />
    <path
      d="M28.293 39.223V22.539s1.086-3.988-13.363 1.637c-.028.07-.028-15.426-.028-15.426l4.72-.027v9.925s13.218-5.207 13.218 3.95v16.62zM30.98 14.73h-5.003c1.8-2.203 3.433-5.98 3.433-5.98h5.176s-.887 2.46-3.606 5.98zM14.988 39.191v-9.496l4.75 4.75z"
      fill="#fff"
    />
  </svg>
);

export default HerokuLogo;



// WEBPACK FOOTER //
// ./src/javascripts/app/Webhooks/templates/logos/HerokuLogo.es6.js